import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  CustomInput
} from "reactstrap";
import CustomButton from "../CustomButton/CustomButton";

import "./index.css";

function ConsentFormModal(props) {
  const [checked, setChecked] = useState(false);

  function handleOnHide() {
    props.onClose();
  }

  function handleOnSubmit() {
    props.onSubmit();
    props.onClose();
  }

  return (
    <Modal
      centered={true}
      isOpen={props.isOpen}
      toggle={handleOnHide}
      backdrop="static"
      id="consent-form-modal"
      className="mx-auto"
      size="lg"
    >
      <ModalHeader>
        <div className="d-flex align-items-center justify-content-between">
          <p>Consent Form</p>
          <div>
            <img
              alt="close"
              onClick={handleOnHide}
              src={require("../../assets/icons/close.png")}
              style={{ width: "15px", cursor: "pointer" }}
            />
          </div>
        </div>
      </ModalHeader>
      <ModalBody>
        <img
          style={{ width: 60 }}
          src={require("../../assets/icons/app-icon.png")}
          alt=""
        />
        <p className="mt-5 mb-2">
          {props.name.firstName} {props.name.middleName} {props.name.lastName}
        </p>
        <p>
          I hereby certify that the information provided in this form is correct
          <br />
          <br />I further consent and authorize the National Identity Management
          Commision to release my NIN information (as may be required) to the
          National Pension Commision (PenCom), upon request by my Pension Fund
          Administrator, for the maintenance and operation of my Retirement
          Savings Account.
          <br />
          <br /> It is my understanding that PenCom shall exercise due care to
          ensure that my information is secure and protected.
        </p>
        <img
          className="mt-4"
          src={props.signature}
          style={{ width: 140 }}
          alt="signature"
        />
      </ModalBody>
      <ModalFooter className="d-flex justify-content-between">
        <CustomInput
          type="checkbox"
          onChange={e => setChecked(e.target.checked)}
          id="agree-checkbox"
          label="Consents that all information provided is correct"
        />
        <CustomButton
          disabled={!checked}
          buttonText="Continue"
          buttonClasses="btn-block"
          onClick={handleOnSubmit}
        />
      </ModalFooter>
    </Modal>
  );
}

ConsentFormModal.defaultProps = {
  onClose: function() {},
  onSubmit: function() {},
  name: {
    firstName: "Izaan",
    lastName: "Jahangir"
  },
  signature:
    "https://upload.wikimedia.org/wikipedia/commons/2/25/Sulli%27s_signature.png"
};

export default ConsentFormModal;
